import { getCurrentUser, signIn } from 'aws-amplify/auth';

export const isAuthenticated = async () => {
  try {
    await getCurrentUser();
    return true;
  } catch (error) {
    return false;
  }
};

export const emailAlreadyHasAnAccount = async (email) => {
  try {
    await signIn({ username: email, password: 'bogusPassword&&123' });
    return true;
  } catch (e) {
    console.log(e);
    return e.name !== 'UserNotFoundException';
  }
};
